import { useInfiniteQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { conversationService } from '../../api/services/conversation.service';
import { ConversationEntity } from '@/entities/conversation/conversation.entity';

export default function useConversation() {
  const { childId } = useParams();

  async function getConversation({
    pageParam = 1,
  }: {
    pageParam: any;
  }): Promise<ConversationEntity> {
    if (!childId) throw new Error('Child ID is required');
    return conversationService.getConversation(childId, pageParam);
  }

  return useInfiniteQuery<ConversationEntity, Error>({
    queryKey: ['conversation', childId],
    queryFn: ({ pageParam }) => getConversation({ pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.currentPage < lastPage.pagination.lastPage
        ? lastPage.pagination.currentPage + 1
        : undefined,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    enabled: !!childId,
  });
}
